(function($) {
    var Sage = {
        'common': {
            init: function() {
                /**
                 * declaracion variables globales
                 */
                var anchoventana=$(document).width();
                var altoventana=$(document).height();
                var md=768;
                var swiperFormulario;

                $('header').after('<section class="padding-header clear"></section>')
                 /**
                  * init plugins y listeners comunes de proyectos
                  */
                 initPlugins();
                 initListeners();
                swiperFormularioSlidePasos=Array(0);
                if ($('#swiperFormulario').length) {
                    swiperFormulario = new Swiper('#swiperFormulario', {
                        slidesPerView: 1,
                        loop: false,
                        simulateTouch: false,
                        mousewheel: {
                            enabled: false,
                        },
                        // scrollbar: {
                        //     el: '.swiper-scrollbar',
                        // },
                    });

                    

                    swiperFormulario.on('slideChangeStart', function (slider) {
                        if (swiperFormularioSlidePasos[swiperFormularioSlidePasos.length-1]!=slider.activeIndex){
                            swiperFormularioSlidePasos.push(slider.activeIndex);
                        }
                        var pct =slider.activeIndex*100/slider.slides.length
                        $("#barraProgreso .barra").css("width",pct+"%");
                        //barraProgreso
                        console.log(swiperFormularioSlidePasos+"--"+pct);
                    });
                }    

                $('#btcontinuar1').on('click', function(e){
                    swiperFormulario.slideTo(1); 
                });
                 

                $('.bt-anonimo').on('click', function(e){
                    $('#ckanonimo').val($(this).attr('data-valor'));
                    $('.bt-anonimo').removeClass('activo');
                    $("#btcontinuar2").removeAttr("disabled");
                    $(this).addClass('activo');
                });

                $('.bt-directiva').on('click', function(e){
                    $('#implicacion_directiva').val($(this).attr('data-valor'));
                    $('.bt-directiva').removeClass('activo');
                    $("#btcontinuar6").removeAttr("disabled");
                    $(this).addClass('activo');
                });

                
                $('.bt-organizacion').on('click', function(e){
                    $('#conocimiento_directiva').val($(this).attr('data-valor'));
                    $('.bt-directiva').removeClass('activo');
                    $("#btcontinuar9").removeAttr("disabled");
                    $(this).addClass('activo');
                });

                $(".js-volverSwiperCumplimiento").click(function (e) { 
                    e.preventDefault();

                    swiperFormularioSlidePasos.pop();//quito el último.
                    jQuery('#swiperFormulario')[0].swiper.slideTo(swiperFormularioSlidePasos[swiperFormularioSlidePasos.length-1]);

                });

                $('#btcontinuar2').on('click', function(e){       
                    console.log('pasa');             
                    if ($('#ckanonimo').val() == '') {
                        $('#alerta-formulario').find('.mensaje-alerta').html('Debes indicar si la denuncia es anónima.');
        	        	$('#alerta-formulario').show();
                    }else{
                        if ($('#ckanonimo').val() == 'si'){
                            swiperFormulario.slideTo(2); 
                        }else{
                            swiperFormulario.slideTo(1); 
                        }                        
                    }     
                });


                $("#swiperFormulario #slide3 input").on("keyup", function() {
                    if ($('#denunciante_nombre').val() != '' && $('#denunciante_apellidos').val() != '' && $('#denunciante_email').val() != '' && $('#denunciante_telefono').val() != '' && $('#denunciante_horario_contacto').val() != '' && $('#denunciante_relacion_empresa').val() != '' ){
                        $("#btcontinuar3").removeAttr("disabled");
                    }
                });

                $("#swiperFormulario #slide3 select").on("change", function() {
                    if ($('#denunciante_nombre').val() != '' && $('#denunciante_apellidos').val() != '' && $('#denunciante_email').val() != '' && $('#denunciante_telefono').val() != '' && $('#denunciante_horario_contacto').val() != '' && $('#denunciante_relacion_empresa').val() != '' ){
                        $("#btcontinuar3").removeAttr("disabled");
                    }
                });                  


                $('#btcontinuar3').on('click', function(e){                    
                    if ($('#denunciante_nombre').val() == '' || $('#denunciante_apellidos').val() == '' || $('#denunciante_email').val() == '' || $('#denunciante_telefono').val() == '' || $('#denunciante_horario_contacto').val() == '' || $('#denunciante_relacion_empresa').val() == '' ) {
                        $('#alerta-formulario').find('.mensaje-alerta').html('Debes indicar todos los datos del denunciante.');
        	        	$('#alerta-formulario').show();
                    }else{
                        if (validarEmail($('#denunciante_email').val()) && validarTelefono($('#denunciante_telefono').val())) {
                            swiperFormulario.slideNext(); 
                        }else{
                            var _errores = '<ul>';
                            if (!validarEmail($('#denunciante_email').val())){
                                _errores += '<li>Debes indicar un email válido.</li>';
                            }
                            if (!validarTelefono($('#denunciante_telefono').val())){
                                _errores += '<li>Debes indicar un teléfono válido.</li>';
                            }
                            _errores += '</ul>'
                            $('#alerta-formulario').find('.mensaje-alerta').html(_errores);
                            $('#alerta-formulario').show();
                        }    

                        
                    }     
                });

                $("#swiperFormulario #slide4 select").on("change", function() {
                    if ($('#tipo_incumplimiento').val() != '' && $('#denuncia_sede').val() != '' ){
                        $("#btcontinuar4").removeAttr("disabled");
                    }
                });                

                $('#btcontinuar4').on('click', function(e){                    
                    if ($('#tipo_incumplimiento').val() == '' || $('#denuncia_sede').val() == '') {
                        $('#alerta-formulario').find('.mensaje-alerta').html('Debes indicar todos los datos del formulario.');
        	        	$('#alerta-formulario').show();
                    }else{
                        swiperFormulario.slideNext();               
                    }     
                });

                $("#swiperFormulario #slide5 select, #swiperFormulario #slide5 input").on("change", function() {
                    if ($('#franquicia').val() != '' && $('#oficinas').val() != '') {
                        $("#btcontinuar5").removeAttr("disabled");
                    }
                });                

                $('#btcontinuar5').on('click', function(e){     
                    if ($('#franquicia').val() == '' || $('#oficinas').val() == '') {
                        $('#alerta-formulario').find('.mensaje-alerta').html('Debes indicar todos los datos del formulario.');
        	        	$('#alerta-formulario').show();
                    }else{
                        swiperFormulario.slideNext();               
                    }                 
                });

                $('#btcontinuar6').on('click', function(e){      
                    if ($('#implicacion_directiva').val() != ''){
                        if ($('#implicacion_directiva').val() == 'si'){
                            swiperFormulario.slideNext();    
                        }else{
                            swiperFormulario.slideTo(8); 
                        }                        
                    }else{
                        $('#alerta-formulario').find('.mensaje-alerta').html('Debes indicar una opción para continuar.');
                        $('#alerta-formulario').show();
                    }           
                });              

                $('#btcontinuar7').on('click', function(e){                    
                    swiperFormulario.slideNext();               
                });

                $('#btcontinuar8').on('click', function(e){                    
                    swiperFormulario.slideNext();               
                });

                $(".js-add-persona").closest(".swiper-slide").find("input").on("keyup", function() {

                    var todorelleno=true;
                    $(this).closest(".swiper-slide").find("input").each(function (index, element) {
                        if ($(this).val()==""){
                            todorelleno=false;
                        }
                    });
                    $(this).closest(".swiper-slide").find("select").each(function (index, element) {
                        if ($(this).val()==""){
                            todorelleno=false;
                        }
                    });                    

                    if (todorelleno){
                        $(this).closest(".swiper-slide").find(".js-add-persona").removeAttr("disabled");
                    }

                    console.log("siiii key "+todorelleno);
                });
                
                $(".js-add-persona").closest(".swiper-slide").find("select").on("change", function() {

                    var todorelleno=true;
                    $(this).closest(".swiper-slide").find("input").each(function (index, element) {
                        if ($(this).val()==""){
                            todorelleno=false;
                        }
                    });
                    $(this).closest(".swiper-slide").find("select").each(function (index, element) {
                        if ($(this).val()==""){
                            todorelleno=false;
                        }
                    });                    

                    if (todorelleno){
                        $(this).closest(".swiper-slide").find(".js-add-persona").removeAttr("disabled");
                    }

                    console.log("siiii change");
                });                

                
                $('#btcontinuar9').on('click', function(e){      
                    if ($('#conocimiento_directiva').val() != ''){
                        if ($('#conocimiento_directiva').val() == 'si'){
                            swiperFormulario.slideNext();    
                        }else{
                            swiperFormulario.slideTo(10); 
                        }                        
                    }else{
                        $('#alerta-formulario').find('.mensaje-alerta').html('Debes indicar una opción para continuar.');
                        $('#alerta-formulario').show();
                    }           
                });
                
                $('#btcontinuar10').on('click', function(e){                    
                    swiperFormulario.slideNext();               
                });

                $("#swiperFormulario #slide11 textarea").on("keyup", function() {
                    if ($('#denuncia_fecha').val() != '' || $('#denuncia_lugar').val() != ''){
                        $("#btcontinuar11").removeAttr("disabled");
                    }
                });

                $('#btcontinuar11').on('click', function(e){                    
                    if ($('#denuncia_fecha').val() != '' || $('#denuncia_lugar').val() != ''){
                            swiperFormulario.slideNext();    
                    }else{
                        $('#alerta-formulario').find('.mensaje-alerta').html('Debes indicar los datos para continuar.');
                        $('#alerta-formulario').show();
                    }                
                });
                
                $('#btcontinuar12').on('click', function(e){                    
                    swiperFormulario.slideNext();               
                });

                $("#swiperFormulario #slide13 textarea").on("keyup", function() {
                    if ($('#denuncia_descripcion').val() != ''){
                        $(".bt-continuar").removeAttr("disabled");
                    }
                });                

                $('.bt-continuar-OLDDDD').on('click', function(e){      
                    if ($('#denuncia_descripcion').val() != ''){
                        $('#fPregunta').submit();
                    }    
                });

                $('.bt-continuar').on('click', function(e){      
                    e.preventDefault();
                    if ($('#denuncia_descripcion').val() != ''){
                        $(this).prop('disabled', true);
                        var form = $('#fPregunta')[0];

                        var formData = new FormData(form);

                        $.ajax({
                            url: "/ajax/save_incumplimiento",
                            dataType: 'json',
                            type: 'POST',
                            data: formData,
                            contentType: false,
                            processData: false,                            
                        })
                        .done(function(data) {
                            //console.log(data);
                            if (data.message == 'OK'){
                                document.location.href="/empresa/"+data.slug+"/gracias";
                            }else{
                                document.location.href="/empresa/"+data.slug+"/error";
                            }
                            
                        })
                        .fail(function(data) {
                            //console.log(data);
                            document.location.href="/empresa/"+data.slug+"/error";
                        });
                    }
                });    

                $('#oficinas').select2({
                    placeholder: 'Escribe el nombre de la oficina', 
                });

                $('input[name=franquicia]').on('change', function() {
                    var franquiciaSeleccionada = $(this).val();

                    $('#oficinas').empty();

                    if (franquiciaSeleccionada === 'Redpiso') {
                        $('#oficinas_redpiso option').each(function() {
                            console.log('pasa con '+$(this).val());
                            $('#oficinas').append('<option value="' + $(this).val() + '">' + $(this).text() + '</option>');
                        });
                    } else if (franquiciaSeleccionada === 'Dcredit') {
                        $('#oficinas_dcredit option').each(function() {
                            $('#oficinas').append('<option value="' + $(this).val() + '">' + $(this).text() + '</option>');
                        });
                    }
                    $('#oficinas').trigger('change.select2');
                });

                // Inicialmente, agregar opciones de 'Redpiso' al select 'oficinas'
                $('#oficinas_redpiso option').each(function() {
                    $('#oficinas').append('<option value="' + $(this).val() + '">' + $(this).text() + '</option>');
                });

                
                function validarEmail(email) {
                    var regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    return regex.test(email);
                }

                function validarTelefono(telefono) {
                    var regex = /^\+\d{2} \(\d{2}\) \d{3} \d{2} \d{2}$/;
                    return regex.test(telefono);
                }
                

            },
            finalize: function() {
                

                
            }
        },
    };
    var UTIL = {
        fire: function(func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';
            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function() {
            // Fire common init JS
            UTIL.fire('common');
            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });
            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };
    $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.